import { safeStringify } from './utils';

export enum GoldenPathStep {
    LOGIN = 'login',
    CREATE_COURSE_START = 'create_course_start',
    DOCUMENT_UPLOAD = 'document_upload',
    DOCUMENT_EXTRACT = 'document_extract',
    COURSE_GENERATE = 'course_generate',
    COURSE_REVIEW = 'course_review',
    COURSE_PUBLISHED = 'course_published',
    LEARNER_OPEN = 'learner_open',
    LEARNER_STUDY = 'learner_study',
    AI_TUTOR_ASK = 'ai_tutor_ask',
    QUIZ_TAKEN = 'quiz_taken',
    PROGRESS_SAVED = 'progress_saved',
    REGENERATE_START = 'regenerate_start',
    DRAFT_CREATED = 'draft_created',
    PREVIEW_READY = 'preview_ready',
    DRAFT_APPROVED = 'draft_approved',
    COURSE_REPUBLISHED = 'course_republished'
}

class DiagnosticTracker {
    private logs: Array<{ timestamp: Date, step: GoldenPathStep, status: 'success' | 'fail' | 'start', details?: any }> = [];

    logStep(step: GoldenPathStep, status: 'success' | 'fail' | 'start', details?: any) {
        const entry = { timestamp: new Date(), step, status, details };
        this.logs.push(entry);
        console.group(`[GOLDEN PATH] ${step.toUpperCase()} - ${status.toUpperCase()}`);
        if (details) console.log(details);
        console.groupEnd();

        try {
            const currentLogs = JSON.parse(localStorage.getItem('golden_path_diagnostics') || '[]');
            currentLogs.push({ ...entry, timestamp: entry.timestamp.toISOString() });
            // keep last 500
            if (currentLogs.length > 500) currentLogs.shift();
            localStorage.setItem('golden_path_diagnostics', safeStringify(currentLogs));
        } catch (e) {
            // ignore
        }
    }

    getLogs() {
        try {
            return JSON.parse(localStorage.getItem('golden_path_diagnostics') || '[]');
        } catch(e) {
            return this.logs;
        }
    }
    
    clearLogs() {
        this.logs = [];
        localStorage.removeItem('golden_path_diagnostics');
    }
}

export const Diagnostics = new DiagnosticTracker();
